import { useEffect, useState } from "react";

import { useAuth } from "../contexts/AuthContext";
import { ApiError, endpoints, type Store } from "../services/api";

export default function StoreSelector() {
  const { currentStoreId, setCurrentStoreId, token } = useAuth();
  const [stores, setStores] = useState<Store[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    endpoints
      .stores()
      .then((list) => {
        if (cancelled) return;
        setStores(list);
        if (list.length > 0 && (currentStoreId === null || !list.some((s) => s.id === currentStoreId))) {
          setCurrentStoreId(list[0].id);
        }
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e instanceof ApiError ? e.message : "Błąd ładowania sklepów");
      });
    return () => {
      cancelled = true;
    };
  }, [token, currentStoreId, setCurrentStoreId]);

  if (error) return <div className="store-selector store-selector--error">{error}</div>;
  if (stores === null) return <div className="store-selector">Ładowanie sklepów…</div>;
  if (stores.length === 0) return <div className="store-selector">Brak sklepów</div>;
  if (stores.length === 1) {
    return <div className="store-selector store-selector--single">📍 {stores[0].name}</div>;
  }

  return (
    <div className="store-selector">
      <label htmlFor="store-select">📍 Sklep:</label>
      <select
        id="store-select"
        value={currentStoreId ?? ""}
        onChange={(e) => setCurrentStoreId(Number(e.target.value))}
      >
        {stores.map((s) => (
          <option key={s.id} value={s.id}>
            {s.name}
          </option>
        ))}
      </select>
    </div>
  );
}
